import React, { useCallback, useState } from 'react';
import { Box } from '@design-system/pc';
import RecentGoodsButton from './FloatingButtons/RecentGoodsButton';
import ConsultButton from './FloatingButtons/ConsultButton';
import { TOP_BUTTON_Z_INDEX } from '@/styles';
import TrackingService from '@/services/tracking';
import FloatingTopButton from './FloatingButtons/FloatingTopButton';

export interface FloatingGroupProps {
  visibleConsultButton?: boolean;
  visibleRecentButton?: boolean;
  zIndex?: number;
}

const FloatingGroup = ({
  visibleConsultButton,
  visibleRecentButton,
  zIndex,
}: FloatingGroupProps) => {
  const [isShowTopButton, setIsShowTopButton] = useState<boolean>(false);

  const handleIsShowTopButton = useCallback((value: boolean) => {
    setIsShowTopButton(value);
  }, []);

  return (
    <Box
      position="fixed"
      right={80}
      bottom={40}
      zIndex={zIndex || TOP_BUTTON_Z_INDEX}
      display="flex"
      flexDirection="column"
      alignItems="center"
      {...TrackingService.tagGTM('floating_group')}
    >
      {visibleRecentButton && (
        <RecentGoodsButton isShowTopButton={isShowTopButton} />
      )}

      {visibleConsultButton && (
        <ConsultButton isShowTopButton={isShowTopButton} />
      )}

      <FloatingTopButton
        isShowTopButton={isShowTopButton}
        handleIsShowTopButton={handleIsShowTopButton}
      />
    </Box>
  );
};

export default FloatingGroup;
